export const setLoadingOn = state => {
  state.isLoading = true;
};

export const setLoadingOff = state => {
  state.isLoading = false;
};
